import styled from 'styled-components';
import { get } from 'lodash';
import React, { Component } from 'react';
import { enableUniqueIds } from 'react-html-id';

const RadioWrapper = styled.div`
    display: inline-block;
    position: relative;
    margin: 0 0 10px;
    font-size: 14px;
    line-height: 24px;

    *, *:before, *:after {
        box-sizing: inherit;
    }

    input {
        position: absolute;
        top: 4px;
        left: 0;
        width: 36px;
        height: 20px;
        opacity: 0;
        z-index: 0;
    }

    label {
        display: block;
        padding: 0 0 0 24px;
        cursor: pointer;
        font-weight: 200;
        color: #000;

        &:before {
            content: '';
            position: absolute;
            top: 4px;
            left: 0;
            width: 16px;
            height: 16px;
            background-color: transparent;
            border: 1px solid #000;
            border-radius: 14px;
            z-index: 1;
            transition: border-color 0.28s cubic-bezier(.4, 0, .2, 1);
        }

        &:after {
            content: '';
            position: absolute;
            top: 8px;
            left: 4px;
            width: 8px;
            height: 8px;
            background-color: ${props => props.theme.forms.radiofill};
            border-radius: 50%;
            z-index: 2;
            transform: scale(0, 0);
            transition: transform 0.28s cubic-bezier(.4, 0, .2, 1);
        }
    }

    input:checked + label {
        &:before {
            border-color: ${props => props.theme.forms.radiofill};
        }

        &:after {
            transform: scale(1, 1);
        }
    }
`;

class RadioButton extends Component {
    constructor(props) {
        super(props);

        enableUniqueIds(this);
    }

    render() {
        const determinedId = get(this.props, 'id', this.getUniqueId('radiobutton'));
        return (
            <RadioWrapper className="radio">
                <input {...this.props.input} id={determinedId} type="radio"/>
                <label htmlFor={determinedId}>{this.props.label}</label>
            </RadioWrapper>
        );
    }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/atoms/form/RadioButton.js